import { Component, OnInit, Input } from '@angular/core';
import { Form } from '../../../shared/form/form.model';

@Component({
	selector: 'app-forms',
	templateUrl: './detail.component.html'
})
export class FormDetailComponent implements OnInit {

  public form: Form;
  
  constructor() {}

  ngOnInit(): void {
    let data = localStorage.getItem('form');
    this.form = new Form().deserialize(JSON.parse(data));
  }
  
}


// WEBPACK FOOTER //
// ./src/app/components/forms/detail/detail.component.ts